export default __webpack_public_path__ + "static/media/sideMenu_plans.cd2d88fc.svg";